// src/admin/layouts/AdminLayout.tsx
// GitHub test push
import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-hot-toast';
import AdminWrapper from '../../components/AdminWrapper';
import Footer from '../../components/Footer';
import NotificationBell from '../../components/NotificationBell';
import ImprovedAdminNavigation from '../components/ImprovedAdminNavigation';
import '../styles/ImprovedAdminNavigation.css';
import ekostratejiLogo from '../../assets/ekostrateji-logo.png';
import '../styles/AdminGlobalStyles.css';

const AdminLayout = () => {
  const { user, profile, signOut } = useAuth(); // signOut'u useAuth'tan alıyoruz
 

  const handleLogout = async () => {
    try {
      // Çıkış işlemini gerçekleştir
      await signOut();
      
      // Başarılı bildirim göster
      toast.success('Çıkış yapıldı');
      
      // Login sayfasına yönlendir
      setTimeout(() => {
        window.location.href = '/auth/login';
      }, 300);
    } catch (error) {
      console.error('Çıkış yaparken hata oluştu:', error);
      toast.error('Çıkış yapılırken bir hata oluştu');
    }
  };

  const activeStyle = {
    fontWeight: 'bold',
    color: '#4CAF50', // Ana renk - yeşil
    backgroundColor: '#e8f5e9', // Hafif yeşil arka plan
    borderLeft: '3px solid #4CAF50', // Sol kenar vurgusu
    paddingLeft: '10px',
  };

  // ROL KONTROLÜ
 const isSuperAdmin = profile?.rol === 'ekostrateji_super_admin';
  const isFirmaAdmin = profile?.rol === 'firma_admin';
  const isFirmaSuperAdmin = profile?.rol === 'firma_super_admin';

  return (
    <AdminWrapper>
      <div className="admin-layout" style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <nav style={{ width: '250px', background: '#f8f9fa', padding: '1.5rem', borderRight: '1px solid #dee2e6', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
        <div>
          <img 
            src={ekostratejiLogo} 
            alt="Ekostrateji Logo" 
            style={{ height: '80px', marginBottom: '1rem', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} 
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h3 style={{ fontSize: '1.25rem', margin: 0 }}>Yönetim Paneli</h3>
            <NotificationBell />
          </div>
          {profile?.tam_adi && (
            <div style={{ marginBottom: '1.5rem', fontSize: '0.9em', color: '#4CAF50', fontWeight: 'bold' }}>
              {profile.tam_adi}
            </div>
          )}
          <ImprovedAdminNavigation 
            isSuperAdmin={isSuperAdmin} 
            isFirmaAdmin={isFirmaAdmin}
            isFirmaSuperAdmin={isFirmaSuperAdmin} 
          />
          <div style={{ marginTop: '1.5rem', borderTop: '1px solid #dee2e6', paddingTop: '1rem' }}>
            <NavLink 
              to="/anasayfa" 
              style={({ isActive }) => ({
                ...(isActive ? activeStyle : { textDecoration: 'none' }),
                color: '#4CAF50',
                fontWeight: 'bold',
                backgroundColor: '#e8f5e9',
                padding: '8px 12px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #4CAF50'
              })}
            >
              <span style={{ fontSize: '1.1em' }}>↩ Raporlama Sürecine Dön</span>
            </NavLink>
          </div>
        </div>
        <div style={{ marginTop: 'auto', marginBottom: '2rem' }}>
          <button 
            onClick={handleLogout} 
            style={{ 
              width: '100%', 
              padding: '0.5rem', 
              background: '#dc3545', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              marginTop: '2rem'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
          >
            Çıkış Yap
          </button>
        </div>
      </nav>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <main className="admin-content" style={{ flex: 1, overflowY: 'auto', padding: '1rem' }}>
          <div className="admin-page">
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
      </div>
    </AdminWrapper>
  );
};

export default AdminLayout;
